import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import PricingPage from "./pages/PricingPage";
import Home from "./pages/Home";
import SubscriptionCheckout from "./pages/SubscriptionCheckout";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      // { path: '/', element: <PricingPage /> },
      { path: "home", element: <Home /> },
      { path: "pricing", element: <PricingPage /> },
      { path: "SubscriptionCheckout", element: <SubscriptionCheckout /> },
    ],
  },
]);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
